import { BehaviorSubject, Subject } from 'rxjs';

export class PlaceStore {
  // have no idea why the custom default place category dispatch doesn't work in event details page's nearby places component
  static customDefaultCategoryStore = new BehaviorSubject<any>(null);
}
